import { Component } from 'react';
import styles from '../../styles/pagination.scss';

interface Props {
  lastPage?: number;
  currentSelectedPage: number;
  onItemClick: any;
  items: any[];
  maxItemsToShow: number;
}

interface State {
  windowStart: number;
}

class PaginationNew extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      windowStart: this.calculateIdealWindowStart(
        props.currentSelectedPage,
        props.items.length,
        props.maxItemsToShow
      ),
    };
  }

  private calculateIdealWindowStart = (
    currentPage: number,
    totalItems: number,
    maxVisible: number
  ): number => {
    const idealStart = Math.max(0, currentPage - Math.floor(maxVisible / 2));
    const maxStart = Math.max(0, totalItems - maxVisible);
    return Math.min(idealStart, maxStart);
  };

  public shiftWindow = (direction: number) => {
    const { windowStart } = this.state;
    const { items = [], maxItemsToShow } = this.props;

    const newWindowStart = windowStart + direction;
    const maxStart = Math.max(0, items.length - maxItemsToShow);

    if (newWindowStart >= 0 && newWindowStart <= maxStart) {
      this.setState({
        windowStart: newWindowStart,
      });
    }
  };

  public componentDidUpdate(prevProps: Props) {
    const { currentSelectedPage, maxItemsToShow, items } = this.props;

    if (
      prevProps.currentSelectedPage !== currentSelectedPage ||
      prevProps.items.length !== items.length
    ) {
      const newWindowStart = this.calculateIdealWindowStart(
        currentSelectedPage,
        items.length,
        maxItemsToShow
      );

      if (this.state.windowStart !== newWindowStart) {
        this.setState({
          windowStart: newWindowStart,
        });
      }
    }
  }

  public render() {
    const { items, onItemClick, currentSelectedPage, maxItemsToShow } =
      this.props;
    const { windowStart } = this.state;

    if (!items || items.length === 0) {
      return null;
    }

    const visibleItems = items.slice(
      windowStart,
      Math.min(windowStart + maxItemsToShow, items.length)
    );

    const canGoLeft = currentSelectedPage > 0;
    const canGoRight = currentSelectedPage < items.length - 1;
    const canShiftLeft = windowStart > 0;
    const canShiftRight = windowStart + maxItemsToShow < items.length;

    return (
      <ul
        className={'lil-flex lil-items-center lil-justify-center center mt30'}
        onClick={onItemClick}
      >
        <li
          className={`lil-text-blue-350 lil-mr-4 ${styles['list-item']} ${
            canGoLeft ? 'lil-cursor-pointer' : 'lil-cursor-not-allowed'
          }`}
          key="prev-button"
          onClick={() => (canShiftLeft ? this.shiftWindow(-1) : undefined)}
          data-click-item={canGoLeft ? currentSelectedPage - 1 : undefined}
        >
          <img
            src="https://assets1.cleartax-cdn.com/cleartax/images/1631780122_down.svg"
            alt="left"
          />
        </li>

        {visibleItems.map((pageNum) => (
          <li
            className={`lil-mx-2 lil-cursor-pointer ${
              pageNum === currentSelectedPage + 1 ? 'lil-text-blue-350' : ''
            } ${styles['list-item']}`}
            key={`page-${pageNum}`}
            data-list-item={true}
            data-click-item={pageNum - 1}
          >
            {pageNum}
          </li>
        ))}

        <li
          className={`lil-text-blue-350 lil-ml-4 ${styles['list-item']} ${
            canGoRight ? 'lil-cursor-pointer' : 'lil-cursor-not-allowed'
          }`}
          key="next-button"
          onClick={() => (canShiftRight ? this.shiftWindow(1) : undefined)}
          data-click-item={canGoRight ? currentSelectedPage + 1 : undefined}
        >
          <img
            src="https://assets1.cleartax-cdn.com/cleartax/images/1631780244_down.svg"
            alt="right"
          />
        </li>
      </ul>
    );
  }
}

export default PaginationNew;



// WEBPACK FOOTER //
// ./components/ui/paginationNew.tsx